import React, { useState } from "react";

const QualityCompliance = ({ onSaveQuality }) => {
  const [qualityData, setQualityData] = useState({
    inspectionParameters: "",
    regulatoryStandards: "",
    testResults: "",
    certificateOfAnalysis: "",
    complianceCertifications: "",
    inspectionFrequency: "",
    nonComplianceActions: "",
    validationChecklist: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQualityData({ ...qualityData, [name]: value });
  };

  const handleSave = () => {
    onSaveQuality(qualityData);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Quality & Compliance</h2>
      <p className="text-gray-600 mb-6">
        Ensure adherence to healthcare-specific quality and compliance
        standards.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Inspection Parameters */}
        <div>
          <label className="block text-gray-700 font-medium">
            Inspection Parameters
          </label>
          <textarea
            name="inspectionParameters"
            value={qualityData.inspectionParameters}
            onChange={handleChange}
            placeholder="e.g., Sterilization Levels, Material Grades"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Regulatory Standards */}
        <div>
          <label className="block text-gray-700 font-medium">
            Regulatory Standards
          </label>
          <input
            type="text"
            name="regulatoryStandards"
            value={qualityData.regulatoryStandards}
            onChange={handleChange}
            placeholder="e.g., FDA, ISO 13485, CE Marking"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Test Results */}
        <div>
          <label className="block text-gray-700 font-medium">
            Test Results
          </label>
          <textarea
            name="testResults"
            value={qualityData.testResults}
            onChange={handleChange}
            placeholder="Enter test result data"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Certificate of Analysis */}
        <div>
          <label className="block text-gray-700 font-medium">
            Certificate of Analysis
          </label>
          <input
            type="text"
            name="certificateOfAnalysis"
            value={qualityData.certificateOfAnalysis}
            onChange={handleChange}
            placeholder="Enter document reference or upload"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Compliance Certifications */}
        <div>
          <label className="block text-gray-700 font-medium">
            Compliance Certifications
          </label>
          <textarea
            name="complianceCertifications"
            value={qualityData.complianceCertifications}
            onChange={handleChange}
            placeholder="e.g., GMP, GLP, WHO Compliance"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Inspection Frequency */}
        <div>
          <label className="block text-gray-700 font-medium">
            Inspection Frequency
          </label>
          <select
            name="inspectionFrequency"
            value={qualityData.inspectionFrequency}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            <option value="">Select Frequency</option>
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
            <option value="Quarterly">Quarterly</option>
            <option value="Annually">Annually</option>
          </select>
        </div>

        {/* Non-Compliance Actions */}
        <div>
          <label className="block text-gray-700 font-medium">
            Non-Compliance Actions
          </label>
          <textarea
            name="nonComplianceActions"
            value={qualityData.nonComplianceActions}
            onChange={handleChange}
            placeholder="e.g., Rejection, Corrective Actions, Escalation"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Validation Checklist */}
        <div>
          <label className="block text-gray-700 font-medium">
            Validation Checklist
          </label>
          <textarea
            name="validationChecklist"
            value={qualityData.validationChecklist}
            onChange={handleChange}
            placeholder="e.g., Equipment Calibration, Process Validation"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
      </div>

      {/* Save Button */}
      <button
        type="button"
        onClick={handleSave}
        className="mt-4 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
      >
        Save Quality Details
      </button>
    </div>
  );
};

export default QualityCompliance;
